import { z } from 'zod';
export const tasksInsuranceClaimsActionsCapability = 'tasks.project-action-summary.v1';
export const tasksInsuranceClaimsActionsSlot = 'insurance-claims.project-actions';
export const tasksInsuranceClaimsActionsProviderId = 'tasks.server.insurance-claims-actions';
const idSchema = z.string().uuid();
const countSchema = z.number().int().nonnegative();
export const tasksInsuranceClaimsActionsRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(tasksInsuranceClaimsActionsCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: idSchema,
    projectId: idSchema,
});
export const tasksInsuranceClaimsActionsStatusCountsSchema = z.strictObject({
    open: countSchema,
    inProgress: countSchema,
    blocked: countSchema,
    done: countSchema,
    cancelled: countSchema,
});
export const tasksInsuranceClaimsActionsResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(tasksInsuranceClaimsActionsCapability),
    projectId: idSchema,
    totalCount: countSchema,
    actionRequiredCount: countSchema,
    byStatus: tasksInsuranceClaimsActionsStatusCountsSchema,
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    observedAt: z.string().datetime({ offset: true }).nullable(),
}).superRefine((value, context) => {
    const statusTotal = Object.values(value.byStatus).reduce((sum, count) => sum + count, 0);
    if (statusTotal !== value.totalCount) {
        context.addIssue({ code: 'custom', path: ['totalCount'], message: 'Task status counts must reconcile.' });
    }
    if (value.byStatus.open + value.byStatus.inProgress + value.byStatus.blocked !== value.actionRequiredCount) {
        context.addIssue({ code: 'custom', path: ['actionRequiredCount'], message: 'Action-required count must include each active task status.' });
    }
});
//# sourceMappingURL=tasks-insurance-claims-actions.contract.js.map